export default {
  "nl": {
    "todo_list": {
      "actions": {
        "add": "Takenlijst toevoegen",
        "cancel": "Cancel",
        "delete_todo_list": "Verwijder takenlijst",
        "edit": "Bewerken",
        "new": "Nieuwe takenlijst",
        "save": "Opslaan",
        "title": "Takenlijst titel"
      },
      "attributes": {
        "name": "Titel"
      },
      "labels": {
        "assignToLevel": "Toewijzen aan level",
        "newTodoList": "Nieuwe Takenlijst"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Behoud overzicht in wat jou en jouw team te doen staat.",
            "title": "Maak een nieuwe takenlijst"
          }
        }
      },
      "toasts": {
        "create": "Takenlijst aangemaakt",
        "delete": "Takenlijst verwijderd",
        "update": "Takenlijst gewijzigd"
      },
      "validation": {
        "needTitle": "Titel vereist"
      }
    }
  }
}